
const LogoLoader = () => {

    try {
        return (
            <>
                <div className="d-flex justify-content-center align-items-center h-100vh" style={{ backgroundImage: `url(/images/Loaderbackground.svg)`}}>
                    <div>
                        <div className='round-logo'>
                            <div className='logo-center-part'>
                                <div className='clippart'></div>
                                <div className='clippartcenter bg-dark border-radius-50 w-12p h-12p'></div>
                                <div className='clippartsecond'></div>
                            </div>
                        </div>
                        <div className='logo-bottomline'></div>
                    </div>
                </div>
            </>
        )
      
    } catch (e) {
      console.log(e)
      return <></>
    }
}

export default LogoLoader
